import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useAnalytics from "../lib/useAnalytics";

/**
 * Scrolls to the top of the page on every route change UNLESS the URL contains
 * an anchor (e.g. /early-access#breeder-apply), in which case the browser's
 * native anchor-scroll behaviour is preserved.
 *
 * v3.99bb — Also drives the site analytics pageview hook (mounted here
 * because both effects must run inside <BrowserRouter> on every route
 * change, and adding a second sibling component would just duplicate
 * the same boilerplate).
 *
 * Mounted once inside <BrowserRouter> in App.js.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useAnalytics();

  useEffect(() => {
    if (hash) return; // intentional anchor target — let browser handle it
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
